import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import TABnavigation from "../components/TABnavigation";
import DesktopHome from "./DesktopView/DesktopHome";
import RedirectButton from "./RedirectButton";
import ClaimRewardsBanner from "../components/ClaimRewardsBanner";



const AuthPage = () => {
  const navigate = useNavigate();
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
  const redirectURL = localStorage.getItem('redirectUrl');

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  const navigateHandler = () => {
    
    const redirectURL = localStorage.getItem('redirectUrl');
    if (redirectURL) {
      window.location.href = redirectURL;
    } else {
      // console.log("No redirect URL found");
    }
  };

  if (isDesktop) {
    return <DesktopHome />;
  }

  return (
    <div className="h-[100vh] bg-gradient-to-b from-[#253246] to-[#1e2738]">
    <div className="h-[90%]  flex justify-center items-center overflow-hidden relative flex-col">
      
      <div className="w-full max-w-[430px] h-screen  flex flex-col justify-between px-6 py-8">
        <div className="flex flex-col items-start pt-4">
          <div className="pr-5 w-full flex items-center justify-between">
            <h1 className="text-[20px] text-white font-light mb-1">Welcome to</h1>
            <div className="h-[30px] w-[30px] cursor-pointer" onClick={() => navigate('/profile')}>
              <img src="/menuButton.png" alt="menu" />
            </div>
          </div>

          <img src="YoGamesXR.png" className="w-[230px]" alt="YoGamezXR Logo" />

          <p className="text-[12px] text-gray-300 text-center px-2 leading-[1.6] max-w-[340px]">
            Experience the future of gaming and immerse yourself in worlds beyond your wildest dreams. Get ready to dive into digital gaming realities like never before.
          </p>
        </div>

        <div className="flex items-center justify-center">
          <img
            src="authpagepeople.png"
            alt="VR Gaming Experience"
            className="w-full max-w-[230px] object-contain"
          />
        </div>

        <ClaimRewardsBanner />

        <div className="pb-3 flex items-center justify-center">
          {/* <button
            type="button"
            className="w-[80%] py-[10px] bg-[#4DD4E8] text-black border-none rounded-xl text-[15px] font-semibold cursor-pointer shadow-lg hover:bg-[#3bc4d8] transition-colors"
            onClick={navigateHandler}
          >
            Start Yo XR Journey
          </button> */}

          <RedirectButton/>
        </div>


         <TABnavigation navHandeler={navigateHandler}/>
      </div>
    </div>
    </div>
  );
};



export default AuthPage;